import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "list", "item", "number"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  dragStart(event) {
    this.draggedItem = event.currentTarget
    this.draggedItem.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  drop(event) {
    event.preventDefault()
    const destination = event.currentTarget
    if (!this.draggedItem || this.draggedItem === destination) return

    const bounds = destination.getBoundingClientRect()
    const insertAfter = event.clientY > bounds.top + (bounds.height / 2)
    destination.insertAdjacentElement(insertAfter ? "afterend" : "beforebegin", this.draggedItem)
    this.renumber()
  }

  dragEnd() {
    if (this.draggedItem) this.draggedItem.classList.remove("is-dragging")
    this.draggedItem = null
  }

  up(event) {
    const item = event.currentTarget.closest("[data-tour-reorder-target='item']")
    if (item?.previousElementSibling) item.previousElementSibling.before(item)
    this.renumber()
  }

  down(event) {
    const item = event.currentTarget.closest("[data-tour-reorder-target='item']")
    if (item?.nextElementSibling) item.nextElementSibling.after(item)
    this.renumber()
  }

  prepare() {
    this.renumber()
  }

  renumber() {
    this.itemTargets.forEach((item, index) => {
      const number = item.querySelector("[data-tour-reorder-target='number']")
      if (number) number.textContent = `Stop ${index + 1}`
    })
  }
}
